<template>
  <div class="tab-list-container">
    <el-button
      class="button-new-tag"
      type="primary"
      size="small"
      @click="showInput"
      >{{ $t("app.new") }}</el-button
    >
    <div
      style="width: 100%; position: relative"
      :key="tag.code"
      v-for="tag in dynamicTags"
    >
      <el-button
        class="tab-btn"
        :type="tag.code === index ? 'primary' : 'info'"
        :icon="tag.gender === 'F' ? 'el-icon-female' : 'el-icon-male'"
        @click="changeSelect(tag)"
      >
        {{ tag.name }}
      </el-button>
      <el-button
        class="edit-btn"
        size="small"
        type="primary"
        icon="el-icon-edit"
        @click="handleEdit(tag)"
      ></el-button>
      <el-button
        class="edit-btn"
        size="small"
        type="danger"
        icon="el-icon-close"
        @click="handleClose(tag)"
      ></el-button>
    </div>
    <tab-modal
      ref="tabModal"
      @handleSuccess="update"
      @handleAdd="add"
    ></tab-modal>
  </div>
</template>

<script>
import TabModal from "./TabModal";
import {
  getFloorList,
  deleteFloor,
} from "@/api/systemManagement/roomManagement";
export default {
  components: {
    TabModal,
  },
  data() {
    return {
      index: "",
      name: "",
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  methods: {
    init() {
      getFloorList().then((res) => {
        this.dynamicTags = res.data
          .sort((a, b) => a.FloorCode - b.FloorCode)
          .map((item) => {
            return {
              code: item.FloorCode,
              name: item.FloorName,
              gender: item.Gender,
              isSupportGuest: item.IsSupportGuest,
              sort: item.Sort,
            };
          });
        if (res.data.length >= 1) {
          this.index = res.data[0].FloorCode;
          this.name = res.data[0].FloorName;
          this.$emit("selectItem", { code: this.index, name: this.name });
        }
      });
    },
    changeSelect(tag) {
      if (this.index === tag.code) {
        return;
      }
      this.index = tag.code;
      this.name = tag.name;
      this.$emit("selectItem", { code: this.index, name: this.name });
    },
    handleClose(tag) {
      this.$confirm(this.$t("app.isDelete") + "?(" + tag.name + ")").then(
        () => {
          deleteFloor({ FloorCode: tag.code }).then(() => {
            this.$message({
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            console.log(this.dynamicTags.length);
            if (tag.code === this.index && this.dynamicTags.length >= 1) {
              this.index = this.dynamicTags[0].code;
              this.name = this.dynamicTags[0].name;
              this.$emit("selectItem", { code: this.index, name: this.name });
            }
          });
        }
      );
    },
    showInput() {
      this.$refs.tabModal.new();
    },
    handleEdit(tag) {
      this.$refs.tabModal.edit(tag);
    },
    add(obj) {
      this.dynamicTags.unshift(obj);
    },
    update(obj) {
      const index = this.dynamicTags.findIndex((item) => {
        return item.code === obj.code;
      });
      this.dynamicTags.splice(index, 1, obj);
    },
  },
};
</script>

<style lang="scss">
.tab-list-container {
  height: 100%;
  overflow: auto;
  padding: 0 10px;
  .tab-btn {
    width: calc(100% - 31px);
    margin-bottom: 10px;
  }
  .button-new-tag {
    width: calc(100% - 30px);
    height: 32px;
    margin-bottom: 10px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .edit-btn {
    position: absolute;
    top: 0;
    right: 0;
    transform: scale(0.7) translate(10px, 25px);

    &:nth-of-type(2) {
      transform: scale(0.7) translate(10px, -6px);
    }
  }
}
</style>
